<template lang="pug">
  v-layout.column
    v-layout.column.style-dimension
      v-layout.align-center
        v-checkbox.checkbox-layers-style.mt-0.pt-2.pb-1(
          :input-value=false
          hide-details :color="color"
          @change="(value) => { setDim=!setDim; validateConfZoom(); }"
        )
        .text-label Forcer les dimensions de la carte
      v-layout.align-center.justify-start.zone.mt-2.ml-4(v-if="this.setDim")
        .text-dimension Largeur:
        input.input-style(v-model="width" @keyup="validateConfZoom")
      v-layout.align-center.justify-start.zone.ml-4(v-if="this.setDim")
        .text-dimension Hauteur:
        input.input-style(v-model="height" @keyup="validateConfZoom")
    textarea.area-style.mt-4(v-model="contentWidget")
    .text Pour afficher le widget, vous devez déclarer votre site internet dans l'onglet "Diffusion"
    v-layout.justify-end
        v-btn.style-maj(@click="CopyToClipboard") Copier le code du widget
    v-snackbar(v-model="copiedSnackbar" bottom left :timeout="2000" color="primary")
          |Le code du widget a été copié dans votre presse-papier
</template>

<script>
import RcColorPicker from '@/components/RcColorPicker.vue';
import mixin from '@/mixins/Rc.mixin.vue';

export default {
  props: {
    config: Object,
  },
  components: {
    RcColorPicker,
  },
  mixins: [mixin],
  data() {
    return {
      contentWidget: '',
      setDim: false,
      width: '800',
      height: '600',
      copiedSnackbar: false,
    };
  },
  mounted() {
    this.contentWidget = `<tmaps-widget conf-id="${this.config.id}" ></tmaps-widget>`;
    // eslint-disable-next-line no-useless-escape
    this.contentWidget += ' <script src="https://tiles.touristicmaps.com/widget/js/app.js"><\/script> ';
  },
  watch: {
    config() {
      this.transientParams = this.filterConfig(this.config);
    },
  },
  methods: {
    CopyToClipboard() {
      this.copiedSnackbar = true;
      const copiedTxt = this.contentWidget;
      navigator.clipboard.writeText(copiedTxt);
    },
    validateConfZoom() {
      if (this.setDim) {
        this.contentWidget = `<div style="width: ${this.width}px; height: ${this.height}px; "><tmaps-widget conf-id="${this.config.id}" ></tmaps-widget></div> `;
      } else {
        this.contentWidget = `<tmaps-widget conf-id="${this.config.id}" ></tmaps-widget>`;
      }
      // eslint-disable-next-line no-useless-escape
      this.contentWidget += ' <script src="https://tiles.touristicmaps.com/widget/js/app.js"><\/script> ';
    },
  },
  computed: {
    color() {
      return this.isChoice ? '#e75239' : 'primary';
    },
  },
};
</script>

<style lang="scss" scoped>
  .checkbox-layers-style{
    flex: none;
  }
  .area-style {
    height: 200px;
    padding: 10px;
    margin: 10px;
    border: 2px solid #ccc;
    background-color: #ddd;
    font-family: Roboto,sans-serif;
    font-weight: bold;
    color: #707070;
  }
  textarea:focus{
    border: 2px solid #ccc;
    outline:none;
  }
  .style-dimension{
    margin: 10px;
    padding: 10px;
  }
  .text-dimension{
    display: flex;
    align-items: center;
    width: 80px;
    height: 30px;
    margin: 10px;
    font-family: Roboto,sans-serif;
    font-size: 15px;
    font-weight: bold;
    color: #A1A1A1;
  }
  .input-style {
    width: 80px;
    height: 40px;
    border-bottom: 1px solid #707070;
    text-align: center;
    font-family: Roboto,sans-serif;
    color: #A1A1A1;
  }
  input:focus{
    border-bottom: 1px solid #e75239;
    outline:none;
  }
  .text{
    font-family: Roboto,sans-serif;
    font-size: 13px;
    font-weight: bold;
    color: #e75239 ;
    width: 80%;
    margin-left: 20px;
  }
  .text-label{
    font-family: Roboto,sans-serif;
    color: #A1A1A1;
    font-size: 15px;
  }
  button.v-btn.style-maj.theme--light {
    width: 180px;
    background-color: #e75239 !important;
    margin-right: 10px;
    margin-top: 20px;
    text-transform: none;
    font-weight: normal;
    color: white;
    border-radius: 5px;
  }
  button.v-btn.size.theme--light {
    position: relative;
    top: -110px;
    right:-5px;
    width: 40px;
    height: 40px;
    min-width: 36px;
    border-radius: 20px;
    color: white;
    background-color: #e75239 !important;
  }
  button.v-btn.size.theme--light:hover
  .v-input.v-textarea.v-text-field.v-text-field--enclosed.v-text-field--outline.theme--light{
    margin: 0 20px;
  }
  .v-input__control {
    display: none !important;
  }
  .v-text-field__details {
    display: none !important;
  }
</style>
